<div class="event-popover-body" cdkDrag>
  <div *ngIf="!editMode">
    <div class="row">
      <div class="d-flex flex-wrap" style="flex-direction: row-reverse;">
        <div ngbDropdown class="d-inline-block">
          <button *ngIf="eventModel.id" type="button" class="btn without-arrow" ngbDropdownToggle><svg
              xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
              <path
                d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z">
              </path>
            </svg></button>
          <div ngbDropdownMenu>
            <button type="button" ngbDropdownItem *ngFor="let calendar of filteredCopyCalendars()"
              (click)="copyEventTo(calendar.id)">Copia evento in {{getUsername(calendar.id)}}</button>
          </div>
        </div>
        <button *ngIf="eventModel.id" (click)="deleteEvent()" type="button" class="btn"><svg
            xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash"
            viewBox="0 0 16 16">
            <path
              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
            <path fill-rule="evenodd"
              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
          </svg></button>

        <button pButton pRipple icon="pi pi-pencil" class="p-button-text p-mr-2" (click)="toggleEditMode()"></button>
        <!-- <div style="margin-top: 7px">
          <mat-slide-toggle [labelPosition]="'before'" [(ngModel)]="eventModel.confermato" [name]="'confermato'">
            Confermato</mat-slide-toggle>
        </div> -->
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <div style="width: 30px; height: 30px; border-radius: 5px;"
          [style.background-color]="findUserColor(eventModel.calendarId)"></div>
      </div>
      <div class="col-10">
        <div>{{ eventModel.confermato ? 'CONFERMATO - ' + eventModel.titolo : eventModel.titolo}}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-2"><i class="pi pi-calendar-times" style="margin-left: 5px;"></i></div>
      <div class="col-10">{{eventModel.dataInizio.day}}/{{eventModel.dataInizio.month}}/{{eventModel.dataInizio.year}}
        {{eventModel.oraInizio}} -
        {{eventModel.dataFine.day}}/{{eventModel.dataFine.month}}/{{eventModel.dataFine.year}}
        {{eventModel.oraFine}} </div>
    </div>
    <div class="row" *ngIf="eventModel.nome || eventModel.cognome || eventModel.cellulare">
      <div class="col-2"><i class="pi pi-user" style="margin-left: 5px;"></i></div>
      <div class="col-10">{{eventModel.nome | titlecase}} {{eventModel.cognome | titlecase}} {{eventModel.nome ||
        eventModel.cognome ? "- " + eventModel.cellulare : eventModel.cellulare}}
      </div>
    </div>
    <div class="row" *ngIf="eventModel.luogo">
      <div class="col-2"><i class="pi pi-compass" style="margin-left: 5px;"></i></div>
      <div class="col-10">{{eventModel.luogo | titlecase}}</div>
    </div>
    <div class="row">
      <div class="col-2"><i class="pi pi-tag" style="margin-left: 5px;"></i></div>
      <div class="col-10">{{getUsername(eventModel.originalCreator) | titlecase}}</div>
    </div>
    <div class="row" *ngIf="eventModel.note">
      <div class="col-2"><i class="pi pi-comment" style="margin-left: 5px;"></i></div>
      <div class="col-10">{{eventModel.note | titlecase}}</div>
    </div>
  </div>
  <div *ngIf="editMode">
    <form #eventForm="ngForm" name="eventForm" class="" (ngSubmit)="eventForm.form.valid && onSubmit()">
      <div class="event-popover-title">
        <div class="row">
          <div class="d-flex flex-wrap" style="flex-direction: row-reverse;">
            <div ngbDropdown class="d-inline-block">
              <button type="button" class="btn without-arrow" ngbDropdownToggle><svg xmlns="http://www.w3.org/2000/svg"
                  width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                  <path
                    d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z">
                  </path>
                </svg></button>
              <div ngbDropdownMenu>
                <div *ngIf="eventModel.id">
                  <button type="button" ngbDropdownItem *ngFor="let calendar of filteredCopyCalendars()"
                    (click)="copyEventTo(calendar.id)">Copia evento in {{getUsername(calendar.id)}}</button>
                </div><button type="button" ngbDropdownItem (click)="secondoCliente = !secondoCliente">{{!secondoCliente
                  ?
                  'Aggiungi': 'Rimuovi'}} secondo cliente</button>
              </div>
            </div>
            <button *ngIf="eventModel.id" (click)="deleteEvent()" type="button" class="btn"><svg
                xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash"
                viewBox="0 0 16 16">
                <path
                  d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                <path fill-rule="evenodd"
                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
              </svg></button>
            <div style="margin-top: 7px">
              <mat-slide-toggle [labelPosition]="'before'" [(ngModel)]="eventModel.confermato" [name]="'confermato'">
                Confermato</mat-slide-toggle>
            </div>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-12">
            <app-singlepicker [(model)]="eventModel.creator" name="agente" [select]="user.email" [myForm]="eventForm"
              [required]="false" [placeholder]="'Agente'" [entity]="'users'" [nameField]="'username'"
              [selectField]="'email'" [includeField]="'agenzia.id'" [included]="[agenzia!.id]"
              (modelChangeComplete)="computeTitle()">
            </app-singlepicker>
          </div>
        </div>
        <div class="row mt-1">
          <div class="form-group col-4  pt-0 mr-0 pr-0">
            <label [for]="'dataInizio'">{{'data appuntamento' | titlecase}}</label>
            <app-datepicker-i18n [(model)]="eventModel.dataInizio"></app-datepicker-i18n>
            <span class="text-danger" *ngIf="(eventModel.dataInizio == null && eventForm.submitted)">
              La data è obbligatoria
            </span>
          </div>
          <div class="form-group col-4 pt-0 mr-0 pr-0">
            <div class="form-group">
              <label [for]="'oraInizio'">{{'ora inizio' | titlecase}}</label>
              <app-timepicker [(model)]="eventModel.oraInizio"></app-timepicker>
              <span class="text-danger" *ngIf="(eventModel.oraInizio == null && eventForm.submitted)">
                L'ora di inizio è obbligatoria
              </span>
            </div>
          </div>
          <div class="form-group col-4 pt-0">
            <div class="form-group">
              <label [for]="'oraFine'">{{'ora fine' | titlecase}}</label>
              <app-timepicker [(model)]="eventModel.oraFine"></app-timepicker>
              <span class="text-danger" *ngIf="(eventModel.oraFine == null && eventForm.submitted)">
                La data fine è obbligatoria
              </span>
            </div>
          </div>
        </div>
        <hr class="sidebar_filter_hr mt-2 mb-2" style="height:2px;">
        <div class="row">
          <div class="col-8">
            <app-singlepicker [sortField]="'tipologia.asc'" [emptyChoice]="true" [emptyModel]="0"
              [(model)]="eventModel.tipoEvento" name="tipoEvento" [myForm]="eventForm" [required]="false"
              [placeholder]="'Tipologia Evento'" [entity]="'evento'" [nameField]="'tipologia'"
              (modelChangeComplete)="selectTipologiaEvento($event);computeTitle()">
            </app-singlepicker>

          </div>
          <div class="col-4">
            <app-singletilepicker [(model)]="eventModel.rifImmobile" [entity]="'immobile'" [name]="'rifImmobile'"
              [freeText]="true" [sortField]="'riferimento.asc'" [placeholder]="'Rif. Immobile'" [field]="'riferimento'"
              [codeField]="'riferimento'" (modelChangeComplete)="computeTitle()" [includeField]="'user.agenzia.id'"
              [included]="[agenzia!.id]" [filters]="{'archiviato':{'value':'false','matchMode':'matchBoolean'}}">
            </app-singletilepicker>
          </div>
        </div>
      </div>
      <div class="event-popover-main">
        <div class="row mt-0">
          <div class="col-3 pt-0 mr-0 pr-0">
            <app-picker [choices]="genereClienteType" [(model)]="eventModel.sig" name="sig" [myForm]="eventForm"
              [required]="false" [placeholder]="'Genere'"></app-picker>
          </div>
          <div class="col-4 pt-0 mr-0 pr-0">
            <app-formfield (onModelChange)="computeTitle()" [placeholder]="'nome'" [name]="'nome'"
              [(model)]="eventModel.nome" [myForm]="eventForm" [required]="false">
            </app-formfield>
          </div>
          <div class="col-5 pt-0">
            <app-formfield (onModelChange)="computeTitle()" [placeholder]="'cognome'" [name]="'cognome'"
              [(model)]="eventModel.cognome" [myForm]="eventForm" [required]="false">
            </app-formfield>
          </div>
        </div>
        <div class="row mt-0">
          <div class="col-6 pt-0 mr-0 pr-0">
            <app-formfield (onModelChange)="computeTitle()" [placeholder]="'cellulare'" [name]="'cellulare'"
              [(model)]="eventModel.cellulare" [myForm]="eventForm" [required]="false">
            </app-formfield>
          </div>
          <div class="form-group col-6 pt-0">
            <div class="form-group">
              <app-formfield (onModelChange)="computeTitle()" [placeholder]="'luogo'" [name]="'luogo'"
                [(model)]="eventModel.luogo" [myForm]="eventForm" [required]="false">
              </app-formfield>
            </div>
          </div>
        </div>
        <div class="row mt-0" *ngIf="secondoCliente">
          <div class="col-3 pt-0">
            <app-picker [choices]="genereClienteType" [(model)]="eventModel.sig2" name="sig2" [myForm]="eventForm"
              [required]="false" [placeholder]="'Genere'"></app-picker>
          </div>
          <div class="col-4 pt-0">
            <app-formfield (onModelChange)="computeTitle()" [placeholder]="'nome'" [name]="'nome2'"
              [(model)]="eventModel.nome2" [myForm]="eventForm" [required]="false">
            </app-formfield>
          </div>
          <div class="col-5 pt-0">
            <app-formfield (onModelChange)="computeTitle()" [placeholder]="'cognome'" [name]="'cognome2'"
              [(model)]="eventModel.cognome2" [myForm]="eventForm" [required]="false">
            </app-formfield>
          </div>
        </div>
        <div class="row mt-0" *ngIf="secondoCliente">
          <div class="col-12 pt-0">
            <app-formfield (onModelChange)="computeTitle()" [placeholder]="'cellulare'" [name]="'cellulare2'"
              [(model)]="eventModel.cellulare2" [myForm]="eventForm" [required]="false">
            </app-formfield>
          </div>
        </div>
        <hr class="sidebar_filter_hr mt-2 mb-2" style="height:2px;">
        <div class="row mt-1">
          <app-formfield [placeholder]="'Specifica Evento'" [name]="'titolo'" [(model)]="eventModel.titolo"
            [myForm]="eventForm" [required]="true">
          </app-formfield>
        </div>
        <div class="row mt-1">
          <app-formfield [placeholder]="'Note'" [name]="'note'" [(model)]="eventModel.note" [myForm]="eventForm"
            [required]="false">
          </app-formfield>
        </div>
      </div>

      <div class="event-popover-actions mt-2">
        <button type="submit" [disabled]="!eventForm.valid || (isLoadingOk)" id="submitButton" class="btn btn-primary">
          Ok
          <span *ngIf="isLoadingOk" class="spinner-border spinner-border-sm" style="width: 1.5rem; height: 1.5rem;"
            role="status" aria-hidden="true"></span>
        </button>
      </div>
    </form>
  </div>
</div>